import { QueryClient } from 'react-query';
import { PaymentPlanDetailsHistoryResponse, PaymentPlanHistoryItem } from '@frontend/api-payment-plans';

export const updatePlanHistoryQueryCache = (
  queryClient: QueryClient,
  paymentPlanId: string,
  newPlanHistoryItem: PaymentPlanHistoryItem
) => {
  queryClient
    .getQueryCache()
    .findAll({
      predicate: (query) => query.queryKey.includes('plan-history') && query.queryKey.includes(paymentPlanId),
    })
    .forEach((query) =>
      query.setData((oldData: PaymentPlanDetailsHistoryResponse) => {
        return {
          ...oldData,
          planHistory:
            oldData?.planHistory?.map((cachedplanHistoryItem) =>
              cachedplanHistoryItem?.payment?.id === newPlanHistoryItem?.payment?.id
                ? newPlanHistoryItem
                : cachedplanHistoryItem
            ) ?? [],
        };
      })
    );
};
